/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Select_PromptInputs */



/**
* | output |
* | --- |
* | "Please select a list from the menu on the left" |
*
* @param {Style_Guide_Manager_Select_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_select_prompt = /** @type {((inputs?: Style_Guide_Manager_Select_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Select_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner une liste dans le menu a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Liste aus dem Menü links aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un elenco dal menu a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите список из меню слева.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione una lista del menú de la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请从左侧菜单中选择一个列表。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左側のメニューからリストを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया बाईं ओर दिए गए मेनू से एक सूची चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma lista no menu à esquerda.")
	return /** @type {LocalizedString} */ ("Please select a list from the menu on the left")
});